import React, { useEffect, useState } from 'react';
import { Table, Modal, Breadcrumb, Button, Card, Row, Col, Tag, Input, Tabs } from 'antd'; import { HomeOutlined, EyeOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useUserProfile from '../../useUserProfile';
import { Tooltip } from 'antd'; // Import Tooltip from Ant Design
import { useTranslation } from 'react-i18next';

interface Nomination {
  approvalId: string;
  nominationId: string;
  nominatorName: string;
  nomineeNames: string[];
  rewardName: string;
  rewardCategory: string;
  approvalStatus: string;
  approvalComments: string;
  unit: string;
  adminApproval: string;
  budget: number;
}

interface NominationDetails {
  nominationId: string;
  nominatorName: string;
  nominatorId: string;
  nomineeNames: string[];
  nomineeIds: string[];
  rewardName: string;
  rewardCategory: string;
  budget: number;
  approvalStatus: string;
  approvalComments: string;
  nominationDate: string;
  nominationMonth: string;
  nominationYear: number;
  approverLevel1: string;
  approverLevel2: string;
  valueDemonstrated: string;
  ecardName: string;
  ecardImage: string;
  rewardTestimonial: string;
}

const AdminApprovalComponent: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nominations, setNominations] = useState<Nomination[]>([]);
  const [selectedNomination, setSelectedNomination] = useState<NominationDetails | null>(null);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [totalBudget, setTotalBudget] = useState(0);
  const [budgetUsed, setBudgetUsed] = useState(0);
  const [budgetRemaining, setBudgetBalance] = useState(0);
  const [rejectNominationId, setRejectNominationId] = useState<string | null>(null);
  const { requestProfileData } = useUserProfile();
  const [adminNominations, setAdminNominations] = useState<Nomination[]>([]);
  const [UserDetails, setUserDetails] = useState<{ id: string, displayName: string, email: string }[]>([]);
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('1'); // Track active tab
  const [isEditingCitation, setIsEditingCitation] = useState(false);
  const [editedCitation, setEditedCitation] = useState('');
  const [editedContribution, setEditedContribution] = useState('');
  const { instance, accounts } = useMsal();
  const [allNominations, setAllNominations] = useState<Nomination[]>([]);
  const [searchText, setSearchText] = useState('');
  const [rewardsApprovalSearch, setRewardsApprovalSearch] = useState('');
  const [adminOnlyApprovalSearch, setAdminOnlyApprovalSearch] = useState('');

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    if (key === '1') {
      fetchNominations();
      fetchAwardsData();
    } else if (key === '2') {
      fetchAdminNominations(true); // pass true for admin
      fetchAwardsData();
    } else if (key === '3') {
      fetchAllNominations();
      fetchAwardsData();
    }
  };

  useEffect(() => {
    fetchToken();
  }, []);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        await requestProfileData();
        const userMail = localStorage.getItem("UserMail");
        const userName = localStorage.getItem("UserName");
        const userId = localStorage.getItem("UserId");
        setUserDetails([{ id: userId || '', displayName: userName || 'Default Nominator', email: userMail || '' }]);
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, [requestProfileData]);
  const fetchAllNominations = async () => {
    try {
      const token = await fetchToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/GetApprovalsData/${false}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      const nominationsWithIndex = response.data.map((nomination: Nomination, index: number) => ({
        ...nomination,
        index: index + 1,
      }));
      setAllNominations(nominationsWithIndex);
    } catch (error) {
      console.error("Error fetching all nominations", error);
    }
  };
  const fetchAdminNominations = async (isAdmin = false) => {
    try {
      const token = await fetchToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/GetApprovalsData/${isAdmin}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      const nominationsWithIndex = response.data.map((nomination: Nomination, index: number) => ({
        ...nomination,
        index: index + 1,
      }));
      setAdminNominations(nominationsWithIndex);
    } catch (error) {
      console.error("Error fetching admin nominations", error);
    }
  };
  useEffect(() => {
    if (UserDetails.length > 0 && UserDetails[0]?.id) {
      fetchNominations();
      fetchAwardsData();
      fetchAdminNominations();
    }
  }, [UserDetails]);
  const fetchNominations = async () => {
    try {
      const token = await fetchToken();
      const Managerid = UserDetails[0]?.id;
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/GetApprovalsDataRequiresApproval`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const nominationsWithIndex = response.data.map((nomination: Nomination, index: number) => ({
        ...nomination,
        index: index + 1,
      }));
      setNominations(nominationsWithIndex);
    } catch (error) {
      console.error("Error fetching nominations", error);
    }
  };
  const handleDeleteNomination = async (nominationId: string) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this nomination? it will be permanently removed.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const token = await fetchToken();
          await axios.delete(
            `${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/${nominationId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          fetchNominations();
          fetchAdminNominations();
          fetchAwardsData();
        } catch (error) {
          console.error('Error deleting nomination', error);
        }
      },
    });
  };
  const fetchAwardsData = async () => {
    try {
      const token = await fetchToken();
      const Managerid = UserDetails[0]?.id;
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Budget/active-main`, {
        headers: {
          'Accept': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      setTotalBudget(response.data.totalBudget);
      setBudgetUsed(response.data.usedBudget);
      setBudgetBalance(response.data.balance);

    } catch (error) {
      console.error("Error fetching awards data", error);
    }
  };

  useEffect(() => {
    if (UserDetails.length > 0 && UserDetails[0]?.id) {
      fetchNominations();
      fetchAwardsData();
    }
  }, [UserDetails]);

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleRejectModalClose = () => {
    setIsRejectModalVisible(false);
    setRejectNominationId(null);
  };

  const handleViewNomination = async (nominationId: string) => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/nomination/${nominationId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.data && response.data.length > 0) {
        setSelectedNomination(response.data[0]);
      }
      setIsModalVisible(true);
    } catch (error) {
      console.error("Error fetching nomination details", error);
    }
  };

  const extractCitation = (description: string): string => {
    const citationRegex = /~citation~([\s\S]*?)~FormFields~|~citation~([\s\S]*)/;
    const match = description.match(citationRegex);
    return match ? (match[1] || match[2] || '').trim() : description;
  };

  const extractBusinessOutcome = (description: string): string => {
    const contributionRegex = /~businessOutcome~([\s\S]*)/;
    const match = description.match(contributionRegex);
    return match ? match[1].trim() : '';
  };
  const handleSubmitNomination = async (nominationId: string, action: 'Approved' | 'Rejected') => {
    try {
      const token = await fetchToken();
      const userid = UserDetails[0]?.id;
      if (!userid) return
      // Map jsonData to the expected format and validate required fields
      const mappedData = [{
        NominationId: nominationId || '',
        Status: action || ''
      }];

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/UploadApprovalsData`,
        {
          UserId: userid,
          NominationLists: mappedData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

      if (activeTab === '1') {
        fetchNominations();
      } else if (activeTab === '2') {
        fetchAdminNominations();
      }

      fetchNominations();
      fetchAwardsData();
      setIsModalVisible(false);
      setIsRejectModalVisible(false);
    } catch (error) {
      console.error(`Error ${action}ing nomination`, error);
    }
  };
  const adminColumns = [
    {
      title: t('No.'),
      dataIndex: 'approvalId',
      key: 'approvalId',
      render: (_: any, record: Nomination) => `${record.approvalId}`,
    },
    {
      title: t('reward_details'),
      dataIndex: 'rewardDetails',
      key: 'rewardDetails',
      render: (_: any, record: Nomination) => ` ${record.rewardName}`,
    },
    {
      title: t('nominee'),
      dataIndex: 'nomineeNames',
      key: 'nomineeNames',
      render: (nomineeNames: string[]) => (
        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 100, display: 'inline-block' }}>
          {nomineeNames?.join(', ') || 'N/A'}
        </span>
      ),
    },
    {
      title: t('nominator'),
      dataIndex: 'nominatorName',
      key: 'nominatorName',
    },
    {
      title: t('AdminActions'),
      key: 'actions',
      render: (_: any, record: Nomination) => {
        const noBudget = budgetRemaining < record.budget;
        const alreadyActioned = record.adminApproval === "Approved" || record.adminApproval=="Rejected";
        console.log( record.adminApproval);
        const approveDisabled = alreadyActioned  || noBudget ;
        const rejectDisabled = alreadyActioned  || noBudget ;
        const deleteDisabled=alreadyActioned;
        // const approveDisabled = false;  
        // const rejectDisabled = false;
        // Confirmation handlers
        const confirmApprove = () => {
          Modal.confirm({
            title: 'Are you sure you want to approve this nomination?',
            okText: 'Approve',
            okType: 'primary',
            cancelText: 'Cancel',
            onOk: () => handleSubmitNomination(record.nominationId, 'Approved'),
          });
        };

        const confirmReject = () => {
          Modal.confirm({
            title: 'Are you sure you want to reject this nomination?',
            okText: 'Reject',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => {
              setRejectNominationId(record.nominationId);
              setIsRejectModalVisible(true);
            },
          });
        };

        const confirmDelete = () => {
          Modal.confirm({
            title: 'Are you sure you want to delete this nomination? It will be permanently removed.',
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => handleDeleteNomination(record.nominationId),
          });
        };

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button icon={<EyeOutlined />} onClick={() => handleViewNomination(record.nominationId)}>View</Button>
              <Button
                danger
                onClick={confirmDelete}
                disabled={deleteDisabled}
              >
                Delete
              </Button>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {record.adminApproval === 'Approved' ? (
                <Button type="primary" disabled style={{ backgroundColor: 'green', borderColor: 'white', color: 'white' }}>
                  Approved
                </Button>
              ) : (
                <Tooltip
                  title={
                    noBudget
                      ? 'No budget'
                      : alreadyActioned
                        ? 'Action not allowed'
                        : Math.floor(budgetUsed) >= Math.floor(totalBudget)
                          ? 'No budget to approve'
                          : ''
                  }
                >
                  <Button
                    icon={<CheckOutlined />}
                    type="primary"
                    disabled={approveDisabled}
                    onClick={confirmApprove}
                  >
                    Approve
                  </Button>
                </Tooltip>
              )}
              {record.adminApproval === 'Rejected' ? (
                <Button type="primary" disabled style={{ backgroundColor: 'Red', borderColor: 'Red', color: 'White' }}>
                  Rejected
                </Button>
              ) : (
                <Tooltip title={noBudget ? 'No budget' : ''}>
                  <Button
                    icon={<CloseOutlined />}
                    danger
                    disabled={rejectDisabled}
                    onClick={confirmReject}
                  >
                    Reject
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  const columns = [
    {
      title: t('No.'),
      dataIndex: 'approvalId',
      key: 'approvalId',
      render: (_: any, record: Nomination) => `${record.approvalId}`,

    },
    {
      title: t('reward_details'),
      dataIndex: 'rewardDetails',
      key: 'rewardDetails',
      render: (_: any, record: Nomination) => `${record.rewardName}`,
    },
    {
      title: t('nominee'),
      dataIndex: 'nomineeNames',
      key: 'nomineeNames',
      render: (nomineeNames: string[]) => (
        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 100, display: 'inline-block' }}>
          {nomineeNames?.join(', ') || 'N/A'}
        </span>
      ),
    },
    {
      title: t('nominator'),
      dataIndex: 'nominatorName',
      key: 'nominatorName',
    },
    {
      title: t('UH_Status'),
      dataIndex: 'approvalStatus',
      key: 'approvalStatus',
      render: (approvalStatus: string) => (
        <div style={{ textAlign: 'center' }}>
          <Tag color={approvalStatus === 'Approved' ? 'green' : approvalStatus === 'Rejected' ? 'red' : 'blue'}>
            {approvalStatus}
          </Tag>
        </div>
      ),
    },
    {
      title: t('AdminActions'),
      key: 'actions',
      render: (_: any, record: Nomination) => {
        const noBudget = budgetRemaining < record.budget;
        const alreadyActioned = record.adminApproval !== null;
        const pendingStatus = record.approvalStatus === 'Pending';
        const approveDisabled = alreadyActioned || pendingStatus || noBudget || record.approvalStatus === 'Rejected';
        const rejectDisabled = alreadyActioned || pendingStatus || noBudget || record.approvalStatus === 'Rejected';
        const deleteDisabled=alreadyActioned;

        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button icon={<EyeOutlined />} onClick={() => handleViewNomination(record.nominationId)}>View</Button>
            {record.adminApproval === 'Approved' ? (
              <Button type="primary" disabled style={{ backgroundColor: 'green', borderColor: 'white', color: 'white' }}>
                Approved
              </Button>
            ) : (
              <Tooltip
                title={
                  noBudget
                    ? 'No budget'
                    : alreadyActioned
                      ? 'Action not allowed'
                      : Math.floor(budgetUsed) >= Math.floor(totalBudget)
                        ? 'No budget to approve'
                        : ''
                }
              >
                <Button
                  icon={<CheckOutlined />}
                  type="primary"
                  disabled={approveDisabled}
                  //disabled={record.adminApproval !== '' || Math.floor(budgetUsed) >= Math.floor(totalBudget) || record.approvalStatus === 'Pending' || record.approvalStatus === 'Rejected'}

                  onClick={() => {
                    Modal.confirm({
                      title: 'Are you sure you want to approve this nomination?',
                      okText: 'Approve',
                      okType: 'primary',
                      cancelText: 'Cancel',
                      onOk: () => handleSubmitNomination(record.nominationId, 'Approved'),
                    });
                  }}
                >
                  Approve
                </Button>
              </Tooltip>
            )}
            {record.adminApproval === 'Rejected' ? (
              <Button type="primary" disabled style={{ backgroundColor: 'Red', borderColor: 'Red', color: 'White' }}>
                Rejected
              </Button>
            ) : (
              <Tooltip title={noBudget ? 'No budget' : ''}>
                <Button
                  icon={<CloseOutlined />}
                  danger
                  disabled={rejectDisabled}
                  onClick={() => {
                    Modal.confirm({
                      title: 'Are you sure you want to reject this nomination?',
                      okText: 'Reject',
                      okType: 'danger',
                      cancelText: 'Cancel',
                      onOk: () => {
                        setRejectNominationId(record.nominationId);
                        setIsRejectModalVisible(true);
                      },
                    });
                  }}
                >
                  Reject
                </Button>
              </Tooltip>
            )}
            <Button
              danger
              style={{ marginLeft: 8 }}
              onClick={() => handleDeleteNomination(record.nominationId)}
              disabled={deleteDisabled}
            >
              Delete
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: '10px 0', backgroundColor: 'white' }}>
      <div style={{ marginBottom: '20px' }}>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '10px',
            boxShadow: '0 1px 1px rgba(215, 219, 219, 0.9)',
            borderRadius: '8px',
            overflow: 'hidden',
            margin: 0,
            padding: 0,
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>
              <th
                style={{
                  width: '33%',
                  padding: '12px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',

                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                {t('Total_Budget')}
              </th>
              <th
                style={{
                  width: '33%',
                  padding: '12px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                {t('Used_Budget')}
              </th>
              <th
                style={{
                  width: '33%',
                  padding: '12px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                {t('balance')}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#ffffff', textAlign: 'center' }}>
              <td
                style={{
                  padding: '10px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  fontSize: '14px',
                  color: '#262626',
                }}
              >
                <strong>{(totalBudget)}</strong>
              </td>
              <td
                style={{
                  padding: '10px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  fontSize: '14px',
                  color: '#262626',
                }}
              >
                <strong>{(budgetUsed)}</strong>
              </td>
              <td
                style={{
                  padding: '10px',
                  borderBottom: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  fontSize: '14px',
                  color: '#262626',
                }}
              >
                <strong>{(budgetRemaining)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={handleTabChange} style={{ marginBottom: 32 }}>
        {/* Rewards Approval Required */}
        <Tabs.TabPane tab={t('Rewards_Approval_Required')} key="1">
          <div style={{ marginBottom: 16 }}>
            <Input.Search
              placeholder="Search by nominee, nominator, or reward"
              value={rewardsApprovalSearch}
              onChange={e => setRewardsApprovalSearch(e.target.value)}
              style={{ marginBottom: 16, width: 300 }}
              allowClear
            />
          </div>
          <Tabs defaultActiveKey="pending" style={{ marginBottom: 16 }}>
            <Tabs.TabPane tab={t('All')} key="All">
              <Table<Nomination>
                dataSource={nominations.filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase())
                )}
                columns={columns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Pending')} key="pending">
              <Table<Nomination>
                dataSource={nominations.filter(n => n.adminApproval == null).filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase())
                )}
                columns={columns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>

            <Tabs.TabPane tab={t('Approved')} key="approved">
              <Table<Nomination>
                dataSource={nominations.filter(n => n.adminApproval === 'Approved').filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase())
                )}
                columns={columns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Rejected')} key="Rejected">
              <Table<Nomination>
                dataSource={nominations.filter(n => n.adminApproval === 'Rejected').filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(rewardsApprovalSearch.toLowerCase())
                )}
                columns={columns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
          </Tabs>
        </Tabs.TabPane>
        {/* Admin Only Approvals */}
        <Tabs.TabPane tab={t('Admin_Only_Approvals')} key="2">
          <Input.Search
            placeholder="Search by nominee, nominator, or reward"
            value={adminOnlyApprovalSearch}
            onChange={e => setAdminOnlyApprovalSearch(e.target.value)}
            style={{ marginBottom: 16, width: 300 }}
            allowClear
          />
          <Tabs defaultActiveKey="pending" style={{ marginBottom: 16 }}>
            <Tabs.TabPane tab={t('All')} key="All">
              <Table<Nomination>
                dataSource={adminNominations.filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase())
                )}
                columns={adminColumns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Pending')} key="pending">
              <Table<Nomination>
                dataSource={adminNominations.filter(n => n.adminApproval === '').filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase())
                )}
                columns={adminColumns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Approved')} key="approved">
              <Table<Nomination>
                dataSource={adminNominations.filter(n => n.adminApproval === 'Approved').filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase())
                )}
                columns={adminColumns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('Rejected')} key="Rejected">
              <Table<Nomination>
                dataSource={adminNominations.filter(n => n.adminApproval === 'Rejected').filter(n =>
                  n.nomineeNames.join(', ').toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.nominatorName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase()) ||
                  n.rewardName.toLowerCase().includes(adminOnlyApprovalSearch.toLowerCase())
                )}
                columns={adminColumns}
                rowKey="nominationId"
                style={{ overflowX: 'auto' }}
                className="custom-table"
              />
            </Tabs.TabPane>
          </Tabs>
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('All_Nominations')} key="3">
          <Input.Search
            placeholder="Search by nominee, nominator, or reward"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            style={{ marginBottom: 16, width: 300 }}
            allowClear
          />
          <Table<Nomination>
            dataSource={allNominations.filter(n =>
              n.nomineeNames.join(', ').toLowerCase().includes(searchText.toLowerCase()) ||
              n.nominatorName.toLowerCase().includes(searchText.toLowerCase()) ||
              n.rewardName.toLowerCase().includes(searchText.toLowerCase())
            )}
            columns={[
              {
                title: t('No.'),
                dataIndex: 'approvalId',
                render: (_: any, record: Nomination) => `${record.approvalId}`,
              },
              {
                title: t('reward_details'),
                dataIndex: 'rewardDetails',
                key: 'rewardDetails',
                render: (_: any, record: Nomination) => ` ${record.rewardName}`,
              },
              {
                title: t('nominee'),
                dataIndex: 'nomineeNames',
                key: 'nomineeNames',
                render: (nomineeNames: string[]) => (
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 100, display: 'inline-block' }}>
                    {nomineeNames?.join(', ') || 'N/A'}
                  </span>
                ),
              },
              {
                title: t('nominator'),
                dataIndex: 'nominatorName',
                key: 'nominatorName',
              },
              {
                title: t('Actions'),
                key: 'actions',
                render: (_: any, record: Nomination) => (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Button icon={<EyeOutlined />} onClick={() => handleViewNomination(record.nominationId)}>View</Button>
                    <Button
                      danger
                      onClick={() => handleDeleteNomination(record.nominationId)}
                    >
                      Delete
                    </Button>
                  </div>
                ),
              },
            ]}
            rowKey="nominationId"
            style={{ overflowX: 'auto' }}
            className="custom-table"
          />
        </Tabs.TabPane>

      </Tabs>
      <Modal
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        centered
        width={700}
        style={{ padding: '10px' }}
      >
        {selectedNomination && (
          <div
            style={{
              padding: '16px',
              backgroundColor: 'white',
              borderRadius: '8px',
            }}
          >
            <h3
              style={{
                margin: 0,
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '16px',
                color: 'rgba(0, 0, 0, 0.88)',
              }}
            >
              {t('reward_details')}
            </h3>
            <Card bordered={false} style={{ marginTop: '16px' }}>
              <Row gutter={[16, 16]} style={{ rowGap: '8px' }}>
                <Col span={12}>
                  <strong>{t('rewards')}</strong>
                  <br /> {selectedNomination.rewardCategory} - {selectedNomination.rewardName}
                </Col>
                <Col span={12}>
                  <strong>{t('nomination_date')}</strong>
                  <br /> {new Date(selectedNomination.nominationDate).toLocaleDateString()}
                </Col>
                <Col span={12}>
                  <strong>{t('month_year')}</strong>
                  <br /> {selectedNomination.nominationMonth} {selectedNomination.nominationYear}
                </Col>
                <Col span={12}>
                  <strong>{t('nominated_by')}</strong>
                  <br /> {selectedNomination.nominatorName || 'N/A'}
                </Col>
                <Col span={12}>
                  <strong>{t('awarded_to')}</strong>
                  <br /> {selectedNomination.nomineeNames?.join(', ') || 'N/A'}
                </Col>
                <Col span={12}>
                  <strong>{t('awarded_points')}</strong>
                  <br /> {selectedNomination.budget} points
                </Col>
                {selectedNomination.approverLevel1 && selectedNomination.approverLevel2 &&
                  <>
                    <Col span={12}>
                      <strong>{t('approval_level1')}</strong>
                      <br /> {selectedNomination.approverLevel1.charAt(0).toUpperCase() + selectedNomination.approverLevel1.slice(1)}
                    </Col>
                    <Col span={12}>
                      <strong>{t('approval_level2')}</strong>
                      <br /> {selectedNomination.approverLevel2.charAt(0).toUpperCase() + selectedNomination.approverLevel2.slice(1)}
                    </Col>
                  </>
                }
                <Col span={12}>
                  <strong>{t('value_demonstrated')}</strong>
                  <br />
                  <Tag
                    style={{
                      backgroundColor: '#8629A4',
                      color: 'white',
                      padding: '4px',
                    }}
                  >
                    {selectedNomination.valueDemonstrated}
                  </Tag>
                </Col>
                {selectedNomination.ecardImage && (
                  <Col span={24}>
                    <div>
                      <strong>{t('ecard')}</strong>
                    </div>
                    <div>
                      <img
                        src={`data:image/jpeg;base64,${selectedNomination.ecardImage}`}
                        alt="E-Card"
                        style={{
                          width: '100%',
                          maxWidth: '300px',
                          height: 'auto',
                          borderRadius: '10px',
                          objectFit: 'cover',
                          marginTop: '10px',
                        }}
                      />
                    </div>
                  </Col>
                )}
                {/* <Col span={24}>
                  <strong>{t('reward_testimonial')}</strong>
                  <br />
                  <Input.TextArea
                    value={extractCitation(selectedNomination.rewardTestimonial)}
                    readOnly
                    style={{
                      width: '100%',
                      height: '80px',
                      resize: 'none',
                    }}
                  />
                </Col> */}
                <Col span={24}>
                  <strong>{t('reward_testimonial')}</strong>
                  <br />
                  {isEditingCitation ? (
                    <>
                      <strong>Citation</strong>
                      <Input.TextArea
                        value={editedCitation}
                        onChange={e => setEditedCitation(e.target.value)}
                        style={{ width: '100%', height: '60px', resize: 'none', marginBottom: 8 }}
                      />
                      <strong>Contribution Towards</strong>
                      <Input.TextArea
                        value={editedContribution}
                        onChange={e => setEditedContribution(e.target.value)}
                        style={{ width: '100%', height: '60px', resize: 'none', marginBottom: 8 }}
                      />
                      <Button
                        type="primary"
                        style={{ marginTop: 8, marginRight: 8 }}
                        onClick={async () => {
                          if (!selectedNomination) return;
                          try {
                            const token = await fetchToken();
                            // Extract the ~FormFields~ section if present
                            const formFieldsMatch = selectedNomination.rewardTestimonial.match(/(~FormFields~[\s\S]*)/);
                            let formFields = formFieldsMatch ? formFieldsMatch[0] : '';

                            // Update only the contributionTowards part in formFields
                            if (formFields) {
                              formFields = formFields.replace(
                                /(~businessOutcome~\s*)([\s\S]*?)(\)?)/,
                                `$1$2\n${editedContribution}$3`
                              );
                            }

                            // Construct the new citation string in the same format
                            const updatedCitation =
                              '~citation~\n' + editedCitation + (formFields ? '\n' + formFields : '');

                            await axios.put(
                              `${process.env.REACT_APP_API_URL}/api/AdminUploadApproval/edit-citation/${selectedNomination.nominationId}`,
                              JSON.stringify(updatedCitation),
                              {
                                headers: {
                                  'Content-Type': 'application/json',
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            );
                            setIsEditingCitation(false);
                            handleViewNomination(selectedNomination.nominationId);
                          } catch (error) {
                            console.error('Error updating citation', error);
                          }
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        style={{ marginTop: 8 }}
                        onClick={() => {
                          setIsEditingCitation(false);
                          setEditedCitation(extractCitation(selectedNomination.rewardTestimonial));
                          setEditedContribution(extractBusinessOutcome(selectedNomination.rewardTestimonial));
                        }}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <>
                      <Input.TextArea
                        value={extractCitation(selectedNomination.rewardTestimonial)}
                        readOnly
                        style={{ width: '100%', height: '80px', resize: 'none', marginBottom: 8 }}
                      />
                      {extractBusinessOutcome(selectedNomination.rewardTestimonial) && (
                        <>
                          <strong>Business Outcome</strong>
                          <Input.TextArea
                            value={extractBusinessOutcome(selectedNomination.rewardTestimonial)}
                            readOnly
                            style={{ width: '100%', height: '60px', resize: 'none', marginBottom: 8 }}
                          />
                        </>
                      )}
                      <Button
                        style={{ marginTop: 8 }}
                        onClick={() => {
                          setIsEditingCitation(true);
                          setEditedCitation(extractCitation(selectedNomination.rewardTestimonial));
                          setEditedContribution(extractBusinessOutcome(selectedNomination.rewardTestimonial));
                        }}
                      >
                        Edit
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </Card>
          </div>
        )}
      </Modal>
      <Modal
        visible={isRejectModalVisible}
        onCancel={handleRejectModalClose}
        footer={null}
        centered
        width={400}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>{t('reject_nomination')}</p>
          <Button onClick={handleRejectModalClose} style={{ marginRight: '10px' }}>{t('cancel')}</Button>
          <Button type="primary" danger onClick={() => rejectNominationId && handleSubmitNomination(rejectNominationId, 'Rejected')}>{t('reject')}</Button>
        </div>
      </Modal>
    </div>
  );
};

export default AdminApprovalComponent;